function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import WillPaginateCollection from './will_paginate_collection';
import ExampleActivity from './example_activity'; // @namespace Model

var ExampleActivities = /*#__PURE__*/function (_WillPaginateCollecti) {
  _inheritsLoose(ExampleActivities, _WillPaginateCollecti);

  function ExampleActivities() {
    return _WillPaginateCollecti.apply(this, arguments) || this;
  }

  ExampleActivities.initClass = function initClass() {
    this.prototype.model = ExampleActivity;
    this.prototype.url = '/api/examples';
  };

  return ExampleActivities;
}(WillPaginateCollection);

ExampleActivities.initClass();
export default ExampleActivities;